import { AnswerType, ICategory } from "../models";

export const round93: ICategory[] = [
	{
		id: "1qxjjkwk1sczm22",
		name: "History of the Internet",
		answers: [
			{
				id: "1qxjjkwk1sczm27",
				type: AnswerType.TEXT,
				answer: "The amount of computers on the earliest form of the internet",
				question: "What is 4?",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2c",
				type: AnswerType.TEXT,
				answer: "The original name for the internet",
				question: "What is ARPANET?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2h",
				type: AnswerType.TEXT,
				answer:
					"To make the internet more accessible, a swiss corp., called CERN, created this language",
				question: "What is HTTP?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2m",
				type: AnswerType.TEXT,
				answer: "The first internet browser",
				question: "What is NetScape Navigator?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2r",
				type: AnswerType.TEXT,
				answer: "A company that was originally made for illegally downloading music",
				question: "What is Napster?",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjjkwk1sczm23",
		name: "The Olden Days",
		answers: [
			{
				id: "1qxjjkwk1sczm28",
				type: AnswerType.TEXT,
				answer: "A method of saving your work from your computer",
				question: "What is a floppy disk?",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2d",
				type: AnswerType.TEXT,
				answer: "An item music was saved on",
				question: "What is a cassette tape?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2i",
				type: AnswerType.TEXT,
				answer: "A piece of your entertainment system that plays VHS tapes",
				question: "What is a VCR?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2n",
				type: AnswerType.TEXT,
				answer: "A portable cassette player",
				question: "What is a walkman?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2s",
				type: AnswerType.TEXT,
				answer: "The storage capacity of a floppy disk",
				question: "What is 1.44 mb?",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjjkwk1sczm24",
		name: "Websites",
		answers: [
			{
				id: "1qxjjkwk1sczm29",
				type: AnswerType.TEXT,
				question: "YouTube",
				answer: "A website to watch popular videos on",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2e",
				type: AnswerType.TEXT,
				answer: "A social media that includes a body part in the title",
				question: "What is Facebook?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2j",
				type: AnswerType.TEXT,
				answer: "The most common search engine among men",
				question: "What is Google?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2o",
				type: AnswerType.TEXT,
				answer: "The most pirated website in America",
				question: "What is Wikipedia?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2t",
				type: AnswerType.TEXT,
				answer: "A place where you can find the things that you've missed, lost, or haven't done.",
				question: "What is your teacher's homepage?",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjjkwk1sczm25",
		name: "Movie Quotes",
		answers: [
			{
				id: "1qxjjkwk1sczm2a",
				type: AnswerType.TEXT,
				answer: '"Just keep swimming!"',
				question: "What is nemo",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2f",
				type: AnswerType.TEXT,
				answer: '"You\'re killing me, smalls."',
				question: "What is sand lot.",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2k",
				type: AnswerType.TEXT,
				answer: "\"It's so fluffy I'm gonna die!\"",
				question: "What is despicable me",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2p",
				type: AnswerType.TEXT,
				answer: '"I\'ll Be back."',
				question: "What is Terminator",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2u",
				type: AnswerType.TEXT,
				answer: '"Don\'t get cocky, kid."',
				question: 'What is Star Wars "A New Hope"',
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjjkwk1sczm26",
		name: "Grab Bag",
		answers: [
			{
				id: "1qxjjkwk1sczm2b",
				type: AnswerType.TEXT,
				answer: "An item that sounds like it can be eaten but is destroyed when let go.",
				question: "What is Apple",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2g",
				type: AnswerType.TEXT,
				answer:
					"You have three doors and you must choose one to go through. Door one is a group of assassins waiting to kill you in door two is a lion whom hasn't eaten for three months and in door three is a fire that has consumed the room. which door do you go through?",
				question: "What is door two. Because the lion is dead it hasn't eaten for three months.",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2l",
				type: AnswerType.TEXT,
				answer:
					"Mary’s father has 5 daughters – Nana, Nene, Nini, Nono. What is the fifth daughters name?",
				question: "If you answered Nunu, you are wrong. It’s Mary!",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2q",
				type: AnswerType.TEXT,
				answer: "what's hi in the middle and round on both ends?",
				question: "What is Ohio",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjjkwk1sczm2v",
				type: AnswerType.TEXT,
				answer: " What is so delicate that saying its name breaks it?\n",
				question: "What is Silence.",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	}
];
